<div class="spb-holder">
  <spb-header></spb-header>
  <div class="spb-plain-content">
    <router-outlet></router-outlet>
  </div>
  <div class="spb-filler"></div>
  <spb-footer [version]="version" [license]="true"></spb-footer>
</div>
<router-outlet name="extra"></router-outlet>
